
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 0.772277 0 0 0 0 0.772277 0 0 0 0 0.772277 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(0 -34)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#000","fill-rule":"nonzero","d":"M24 46c0-6.628-5.372-12-12-12S0 39.372 0 46s5.372 12 12 12c.07 0 .14 0 .21-.005v-9.337H9.634v-3.005h2.578v-2.212c0-2.564 1.566-3.961 3.853-3.961 1.097 0 2.04.08 2.311.117v2.681H16.8c-1.242 0-1.486.59-1.486 1.458v1.912h2.977l-.39 3.005h-2.587v8.883C20.33 56.096 24 51.48 24 46z"}})])])
          )
        }
      }
    